export default {
    bindings: {
    },
    controller: 'arrivalDashboardController',
    template: require('../views/arrival.dashboard.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/guests/components/arrival.dashboard.component.js